import { Component, computed, inject, input, OnInit, signal, TemplateRef, viewChild } from '@angular/core'
import { SmartquoteService } from '../services/smartquote.service'
import { SmartQuote } from '../interfaces/smartquote.interface'
import { Router } from '@angular/router'
import { CurrencyPipe, DatePipe, JsonPipe, LowerCasePipe, NgClass } from '@angular/common'
import { ButtonComponent } from '../../../shared/components/form/button/button.component'
import { ConfigService } from '../../../services/config.service'
import { NgbAlertModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'sf-smartquote-acceptance',
    imports: [NgbAlertModule, ButtonComponent, CurrencyPipe, JsonPipe, DatePipe, LowerCasePipe, NgClass],
    templateUrl: './smartquote-acceptance.component.html',
    styleUrl: './smartquote-acceptance.component.scss',
})
export class SmartquoteAcceptanceComponent implements OnInit {
    #configService = inject(ConfigService)
    #modalService = inject(NgbModal)
    #router = inject(Router)
    #smartquoteService = inject(SmartquoteService)

    acceptedModal = viewChild<TemplateRef<any>>('acceptedModal')

    config = this.#configService.config

    id = input.required<string>()

    smartQuote = signal<SmartQuote | null>(null)

    awaitingResponse = computed(() => {
        const quote = this.smartQuote()
        return !quote || (!quote.isAccepted && !quote.isDeclined)
    })

    ngOnInit(): void {
        this.#smartquoteService.getSmartquote(this.id()).subscribe({
            next: quote => {
                this.smartQuote.set(quote)
            },
            error: err => {
                this.#router.navigate(['/error'], {
                    queryParams: { message: 'Failed to load smart quote' },
                })
            },
        })
    }

    acceptQuote(): void {
        this.#smartquoteService.acceptSmartquote(this.id()).subscribe({
            next: () => {
                this.smartQuote.update(quote => (quote ? { ...quote, isAccepted: true, isDeclined: false } : quote))

                this.#modalService.open(this.acceptedModal(), { centered: true, size: 'lg' })
            },
            error: err => {},
        })
    }

    downloadPdf(): void {
        this.#smartquoteService.downloadPdf(this.id()).subscribe({
            next: file => {
                const blob = new Blob([file.data as BlobPart], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)
                const anchor = document.createElement('a')
                anchor.download = file.filename || `quote-${this.id()}.pdf`
                anchor.href = url
                anchor.click()
            },
        })
    }
}
